import type { ModulationSessionStats } from '@tunasong/music-lib'
import { Button } from '@tunasong/ui-lib'
import { type FC } from 'react'
import styles from './modulation-lab-summary.module.css'

export interface ModulationLabSummaryProps {
  stats: ModulationSessionStats
  onRestart: () => void
  onExit: () => void
}

/**
 * Session-end summary — total score plus per-technique breakdown. Empty
 * technique buckets are omitted (a session may not include all four
 * techniques in 10 random questions).
 *
 * Spec: docs/superpowers/specs/2026-05-26-modulation-lab-v1-design.md §6
 */
export const ModulationLabSummary: FC<ModulationLabSummaryProps> = props => {
  const { stats, onRestart, onExit } = props
  const techniques = Object.keys(stats.byTechnique) as (keyof typeof stats.byTechnique)[]
  return (
    <div className={styles.summary}>
      <h2 className={styles.title}>Session complete</h2>
      <div className={styles.score}>
        {stats.correct} / {stats.total}
      </div>
      <ul className={styles.byTech}>
        {techniques.map(t => {
          const bucket = stats.byTechnique[t]
          if (bucket.total === 0) {return null}
          return (
            <li key={t}>
              {t}: {bucket.correct} / {bucket.total}
            </li>
          )
        })}
      </ul>
      <div className={styles.actions}>
        <Button type="button" onClick={onRestart}>
          Try again
        </Button>
        <Button type="button" variant="outlined" onClick={onExit}>
          Back
        </Button>
      </div>
    </div>
  )
}
